import { FC } from "react"

import { getReservationStatusLabel, ReservationStatus } from "models/Reservation"
import StatusTag from "components/StatusTag/StatusTag"

function getReservationStatusColorClass(status: ReservationStatus) {
    return {
        [ReservationStatus.reserved]: 'bg-grey-400',
        [ReservationStatus.confirmed]: 'bg-green-400',
        [ReservationStatus.shipping]: 'bg-purple-400',
        [ReservationStatus.active]: 'bg-green-400',
        [ReservationStatus.return]: 'bg-purple-400',
        [ReservationStatus.finalSettlement]: 'bg-yellow-500',
        [ReservationStatus.completed]: 'bg-yellow-500',
        [ReservationStatus.invoice]: 'bg-yellow-500',
        [ReservationStatus.closed]: 'bg-grey-400',
        [ReservationStatus.canceled]: 'bg-red-400',
    }[status] || 'bg-grey-400'
}

interface IReservationStatusTagProps {
    status: ReservationStatus
    compact?: boolean
}

const ReservationStatusTag: FC<IReservationStatusTagProps> = ({
    status,
    compact = false
}) => {
    const text = getReservationStatusLabel(status)
    const bgColorClass = getReservationStatusColorClass(status)
    return (
        <StatusTag className={bgColorClass} compact={compact}>
            {text}
        </StatusTag>
    )
}

export default ReservationStatusTag
